var last = 0;
var hacked = 0;
tarteaucitronForceExpire = 180;

    tarteaucitron.init({
        "privacyUrl": "/donnees-personnelles/",
        "hashtag": "#tarteaucitron",
        "cookieName": "tartaucitron",
        "AcceptAllCta" : true,
        "DenyAllCta" : true,
        "handleBrowserDNTRequest": false,
        "moreInfoLink": true,
        "useExternalCss": true,
        "highPrivacy": true,
        "orientation": "bottom",
        "adblocker": false,
        "showAlertSmall": false,
        "showIcon": false,
        "cookieslist": false,
        "removeCredit": true,
        'alertBigPrivacy': "Lorsque vous naviguez sur notre site internet, des informations sont enregistrées ou lues dans votre terminal, afin d'analyser et d'améliorer la performance de votre navigation, ainsi que nous permettre de mesurer l'audience du site et de lire une vidéo. Consultez notre politique sur les cookies pour de plus amples informations.",
        'disclaimer': "Lorsque vous naviguez sur notre site internet, des informations sont enregistrées ou lues dans votre terminal, afin d'analyser et d'améliorer la performance de votre navigation, ainsi que nous permettre de mesurer l'audience du site et de lire une vidéo. Consultez notre politique sur les cookies pour de plus amples informations.",
    });

    (tarteaucitron.job = tarteaucitron.job ||[]).push('vimeo');



function checkSticky(){
    let y = window.pageYOffset;
    let offset =jQuery('.empty').offset(); 
    if(y >= offset.top){
        $('#menu-header').addClass('is-stuck');
    }else{
        $('#menu-header').removeClass('is-stuck');
    }
    last = window.scrollY;
}

document.addEventListener('scroll', function(e){
    checkSticky(); 
    if(hacked == 0){
        hackForm();
    }
});

$(document).ready(function(){
    checkSticky();
    let href = $("#map .adresse a");
    href.html(href.data('href')).prop('href',"mailto:"+href.data('href'));

});

$('#contact').on('click scroll', function(){
 
    if(hacked == 0){
        hackForm();
    }

});

$("body").on('click', "#actus .loadmore", function(){
    $(this).data('text',$(this).children('span').html()).prop('disabled',true).children('span').html('<i class="fas fa-spin fa-spinner"></i>');
    $('#moreloaded').html("");
    $('#moreloaded').load($(this).data('link')+" #actus",function(){
        $("#main-content > #actus .posts .card-columns").append($('#moreloaded .posts > .row').html());
        let link = $('#moreloaded .pagination button').data('link');
        if(typeof(link) !== 'undefined'){
            $('#main-content > #actus .pagination button').data('link',link).prop('disabled',false).children('span').html($('#main-content > #actus .pagination button').data('text'));

        }else{
            $('#main-content > #actus .pagination button').hide();
        }
        $('#moreloaded').html("");
    });

});

$("body").on('click', "#offres .loadmore", function(){
    $(this).data('text',$(this).children('span').html()).prop('disabled',true).children('span').html('<i class="fas fa-spin fa-spinner"></i>');
    $('#moreloaded').html("");
    $('#moreloaded').load($(this).data('link')+" #offres",function(){
        $("#main-content > #offres .posts > .row").append($('#moreloaded .posts > .row').html());
        let link = $('#moreloaded .pagination button').data('link');
        if(typeof(link) !== 'undefined'){
            $('#main-content > #offres .pagination button').data('link',link).prop('disabled',false).children('span').html($('#main-content > #offres .pagination button').data('text'));

        }else{
            $('#main-content > #offres .pagination button').hide();
        }
        $('#moreloaded').html("");
    });

});

$('.backtotop').on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
        scrollTop: 0
    }, 700);
});

$('html').click(function(e) {
    if ($(e.target).parents('#menu-header').length == 0) {
        $('#main-nav.opened').hide().removeClass('opened');
    }
});

/*$('#canvas, #map .adresse i').on('click',function(){*/
$('#map .adresse i').on('click',function(){
    $('#map .adresse').hide();
});
$("#canvas img").on('click',function(){
    console.log('click');
    $('#map .adresse').show();
});
$("#canvas > div > div > div > div > div > div > div").on('click',function(){
    console.log('click');
    $('#map .adresse').show();
});

/* Hack drag & drop pour iOS Safari */
function hackForm(){
    $('#field_2_11, #field_2_12').each(function(){
        let id = $(this).find('input[type="file"]').attr('id');
        $(this).find('label').attr('for',id);
    });
    hacked = 1;
}